export default "__VITE_ASSET__a60e7978__"